import React from "react";
import {Button, Dialog, Text, View} from "@unibuddy/patron";

type IntroVideoPopupProps = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export function IntroVideoPopup({isOpen, setIsOpen}: IntroVideoPopupProps) {
    return (
        <Dialog
            isOpen={isOpen}
            onDismiss={() => setIsOpen(false)}
            CloseButton={() => null}
            size="xsmall"
        >
            <View padding="large" alignItems="center" gap="large">
                <Text size="large" align="center">
                    It looks like this ambassador hasn’t added an intro video yet.
                </Text>
                <Button size="lg" onClick={() => setIsOpen(false)} block>
                    Got it
                </Button>
            </View>
        </Dialog>
    );
}
